export const getDomainFromEmail = userEmail => {
  if (!userEmail) {
    return '';
  }
  const domain = userEmail.split('@')[1];
  if (!domain) {
    return '';
  }
  return domain;
};